import { MultiSelect as MMultiSelect } from '@mantine/core';
import classes from './multiSelect.module.scss';
import { IconSelector } from '@tabler/icons-react';

export const MultiSelect = MMultiSelect.extend({
  classNames: { ...classes },
});

MultiSelect.defaultProps = {
  defaultOpened: true,
  rightSection: (
    <IconSelector size={20} color='var(--mantine-color-primary-7)' />
  ),
};
